import { tns } from '../../node_modules/tiny-slider/src/tiny-slider.module.js';
import { gsap } from "../../node_modules/gsap/index.js";
import { ScrollTrigger } from "../../node_modules/gsap/ScrollTrigger.js";
import { Utilities } from "./utilities.js";

gsap.registerPlugin(ScrollTrigger);

export class FCSlider {

    slider;

    constructor(options = {}) {
        this.options = options;
        this.bigButtonSlider_init(); 
    }

    heroSlider() {
        this.heroSlider_dynamicSize();
        this.heroSliderCollection_dynamicSize();
        //this.heroSlider_onResize();
        //this.heroSlider_init();
        this.heroSlider_sliderItems();
        this.bannerSlider_init();
        jQuery(window).on('load', () => {
            this.heroSlider_init();
        });
    }

    heroSlider_onResize() {
        jQuery(window).on('resize', () => {
            this.heroSlider_dynamicSize();
            this.heroSliderCollection_dynamicSize();
            this.heroSlider_sliderItems();
        });
    }

    heroSlider_dynamicSize() {
        let hero = jQuery('.hero-window-height:not(.collection-slider)');
        let viewportHeight = jQuery(window).height();
        hero.height(viewportHeight);
        hero.find('.hero--stage, .hero--item, .hero--item-image').height(viewportHeight);
    }

    heroSliderCollection_dynamicSize() {
        const hero = jQuery('.hero-window-height.collection-slider');
        const viewportHeight = jQuery(window).height();
        const headerHeight = jQuery('#masthead').outerHeight();
        const collectionmenuheight = jQuery('.collection--menu').outerHeight();
        //console.log("collectionmenuheight is " + collectionmenuheight);
        const heroHeight = viewportHeight - headerHeight - collectionmenuheight;
        hero.height(heroHeight);
        hero.find('.hero--stage, .hero--item, .hero--item-image').height(heroHeight);
    }
    

    heroSlider_init() {
        if( jQuery('.hero-slider:not(.collection-slider) .hero--stage').length ) {

            let autoplay = ( jQuery('.hero-slider').attr('data-autoplay') == 'true' ) ? true : false;
            let controls = ( jQuery('.hero-slider').attr('data-controls') == 'true' ) ? true : false;
            let loop = ( jQuery('.hero-slider').attr('data-loop') == 'true' ) ? true : false;

            let sliderOptions = {
                container: '.hero--stage',
                speed: 900,
                items: 1,
                slideBy: 'page',
                autoplay: autoplay,
                loop: loop,
                controls: controls,
                nav: false,
                autoplayButtonOutput: false,
                navPosition: 'bottom',
                mouseDrag: true,
                lazyload: true,
                swipeAngle: false,
                preventScrollOnTouch: 'force',
                //startIndex: jQuery('.hero-slider').attr('data-start_index')
            };
            
            if ( controls) {
                sliderOptions.prevButton = '.hero-slider--control.control-prev';
                sliderOptions.nextButton = '.hero-slider--control.control-next';
            }

            this.slider = tns(sliderOptions);

            if( controls ) {
                this.heroSlider_removeFirstAndLastArrows();
            }
            

        } else if(jQuery('.hero-slider.collection-slider .hero--stage').length) {
            this.slider = tns({
                container: '.hero--stage',
                speed: 900,
                items: 1,
                slideBy: 'page',
                autoplay: false,
                loop: true,
                controls: true,
                prevButton: '.hero-slider--control.control-prev',
                nextButton: '.hero-slider--control.control-next',
                //navContainer: '.com--iid-slider--dots',
                nav: true,
                navPosition: 'bottom',
                startIndex: jQuery('.hero-slider').attr('data-start_index'),
                swipeAngle: false,
                preventScrollOnTouch: 'force',
            });
        }
        if(jQuery('.hero-slider.collection-slider-menu .menu--stage').length) {
            /*if( window.matchMedia("(max-width: 768px)").matches ) {
                this.slider = tns({
                    container: '.menu--stage',
                    items: 3.5,
                    slideBy: 'page',
                    autoplay: false,
                    loop: false,
                    controls: true,
                    autoWidth: true,
                    prevButton: '.control-menu.control-prev',
                    nextButton: '.control-menu.control-next',
                    //navContainer: '.com--iid-slider--dots',
                    nav: false,
                    navPosition: 'top',
                    mouseDrag: true,
                    startIndex: jQuery('.collection-slider-menu').attr('data-start_index')
                });
            }*/
            this.slider = tns({
                container: '.menu--stage',
                items: 3.5,
                slideBy: 'page',
                autoplay: false,
                loop: false,
                controls: true,
                autoWidth: true,
                prevButton: '.control-menu.control-prev',
                nextButton: '.control-menu.control-next',
                //navContainer: '.com--iid-slider--dots',
                gutter: 20,
                nav: false,
                navPosition: 'top',
                mouseDrag: true,
                startIndex: jQuery('.collection-slider-menu').attr('data-start_index'),
                swipeAngle: false,
                preventScrollOnTouch: 'force',
            });
        }
    }

    heroSlider_removeFirstAndLastArrows() {
        console.log('slider info');
        console.log(this.slider.getInfo());
        let last_slider_index = this.slider.getInfo().slideCount - 1;
        this.slider.events.on('transitionEnd', () => {
            
            let slider_info = this.slider.getInfo();
            
            if( slider_info.index == 0 ) {
                jQuery('.hero-slider--control.control-prev').addClass('hidden-control');
            }else{
                jQuery('.hero-slider--control.control-prev').removeClass('hidden-control');
            }

            if( slider_info.index == last_slider_index ) {
                jQuery('.hero-slider--control.control-next').addClass('hidden-control');
            }else{
                jQuery('.hero-slider--control.control-next').removeClass('hidden-control');
            }

        });
    }

    heroSlider_sliderItems() {
        
        if( jQuery('.hero .hero--stage .dyn-item').length ) {
            let mm = gsap.matchMedia();
            jQuery('.hero .hero--stage .dyn-item').each( (index,element) => {
                let media_data = jQuery(element).data('media');
                let markup = "";

                //console.log(media_data);

                if (window.matchMedia("(orientation: portrait)").matches) {
                    // Portrait
                    markup = (media_data.mime_type == 'video') ? this.mountVideoItem(media_data.mobile) : this.mountImageItem(media_data.mobile,media_data.alt);
                } else {
                    // Landscape
                    markup = (media_data.mime_type == 'video') ? this.mountVideoItem(media_data.desktop) : this.mountImageItem(media_data.desktop,media_data.alt);
                }
                //console.log(markup);
                jQuery(element).html(markup);

                if( media_data.mime_type == 'video') {
                    const videoElem = jQuery(element).find("video")[0];
                    //const videoElem = document.querySelector(".hero--item-image.dyn-item video");
                    if( videoElem.length > 0 ) console.log('video element found');
                    const sliderTitle = document.querySelector(".hero--item-caption--title");
                    try {
                        videoElem.play();
                        setTimeout(() => {
                            gsap.to(sliderTitle, {opacity: 0, duration: 1.5});
                        },2000);
                    } catch (err) {
                        //playButton.classList.remove("playing");
                    }
                }

                if ( Utilities.elementExits(".hero--item-image.parallax") ) {


                    //parallax animation mobile
                    mm.add("(orientation: portrait)", () => {
                        gsap.from(".hero--item-image.parallax img", {
                            top: "100px",
                            ease: "none",
                            scrollTrigger: {
                              trigger: ".hero--item-image",
                              scrub: 0.5
                            }
                        });
                    });

                    //parallax animation desktop
                    mm.add("(orientation: landscape)", () => {
                        gsap.from(".hero--item-image.parallax img", {
                            objectPosition: "50% 100%",
                            //opacity: 0.2,
                            ease: "none",
                            scrollTrigger: {
                              trigger: ".hero--item-image",
                              //start: "top bottom",
                              //end: "bottom top",
                              scrub: 0.5
                            }
                        });
                    });

                }

            });
            //this.slider.destroy();
            if( this.slider ) {
                this.slider.refresh();
            }
            
        }  
    }

    mountVideoItem(url) {
        let video = '<video autoplay loop muted playsinline>';
        video += '<source src="' + url + '" type="video/mp4">';
        video += '</video>';
        return video;
    }

    mountImageItem(url,alt) {
        return '<img src="' + url + '" alt="' + alt + '" />';
    }

    placeShortcodeTextInAdminField() {
        let post_ID = ( jQuery('#post_ID').length ) ? jQuery('#post_ID').val() : "";
        if( post_ID != "" ) {
            jQuery('input#slider_shortcode').val('[fc_slider id="' + post_ID + '"]');
        }
    }

    bigButtonSlider_init() {
        //.big-image-button--slider
        if( jQuery('.big-image-button--slider').length ) {
            jQuery('.big-image-button--slider').each( (index,element) => {
                let slider = tns({
                    mode: 'gallery',
                    container: element,
                    items: 1,
                    slideBy: 'page',
                    autoplay: true,
                    loop: true,
                    controls: false,
                    nav: false,
                    autoplayButtonOutput: false,
                    speed: 2000,
                    animateDelay: 100,
                });
            });
        }
    }

    bannerSlider_init() {
        if( jQuery('.banner-slider').length ) {
            let slider = tns({
                mode: 'gallery',
                container: '.banner-slider',
                items: 1,
                slideBy: 'page',
                autoplay: true,
                loop: true,
                controls: false,
                nav: false,
                autoplayButtonOutput: false,
                speed: 2000,
                animateDelay: 100,
            });
        }
    }

}